export default __webpack_public_path__ + "908817d7fd6300d3929a6e245b61a333.png";